
// 公众号动态路由接口
import request from '../utils/service'

const api = {
  getWebPageConfig() {
    return request({
      url: '/basic/v2/api/webPageConfig',
      methods: 'get'
    })
  },
  getWebPageUrl(params) {
    return request({
      url: '/basic/v2/api/getH5Url',
      methods: 'get',
      params: params
    })
  },
  getHomeMenu(params) {
    return request({
      url: '/basic/v2/api/homeFuncEntries',
      methods: 'get',
      params: params
    })
  }

}

export default api
